import apiClient from 'utilities/apiClient';

export const materials = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.materialList}/${url}`, payload, true);
};

export const inventory = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.inventory}/${url}`, payload, true);
};
